import { loadYoga, type Yoga } from "yoga-layout/wasm-async";
import { devLogger } from "@certa/common/utils/devLogger.ts";

let _yoga: Yoga | null = null;

export const yoga = {
  init: async function () {
    if (_yoga) return _yoga;
    try {
      _yoga = await loadYoga();
      devLogger.log("Yoga layout loaded");
      return _yoga;
    } catch (e) {
      devLogger.error("Failed to load Yoga layout", e);
      throw e;
    }
  },
  get instance() {
    if (!_yoga) {
      throw new Error("Yoga layout not loaded");
    } else return _yoga;
  },
  createNode: function () {
    if (!_yoga) {
      throw new Error("Yoga layout not loaded");
    } else {
      return this.instance.Node.create();
    }
  }
};
